<script>
export default {
  name: 'snackbar-error',
  props: {
    error: [String, Number],
    value: [Boolean],
    positionAbsolute: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timeout: 2000,
    };
  },
  methods: {
    hide() {
      this.$emit('input', false);
    },
  },
};
</script>

<template lang="pug">
v-snackbar#snackbar-error(:class="$style.wrapper", :timeout="timeout",
  :absolute="positionAbsolute", :error="'error'", :value="value", @input="$emit('input', $event)")
  div#error-text {{ typeof error === 'number' ? $t(`T_RESPONSE_${error}`) : error }}
  div(@click="hide")
    slot
      ui-button {{ $t('T_CLOSE') }}
</template>
<style lang="sass" module>
.wrapper
  width: auto
  display: flex
  flex-direction: row
  justify-content: center
</style>
